import { Project } from "./project"

export interface Scenario {
  id: number
  createdAt: number
  updatedAt: number
  isDeleted: boolean
  deletedAt: number
  deletedBy: string
  nodeCount?: number
  name: string
  status: ScenarioStatus
  startNodeKey: string
  project: Project
  nodes?: ScenarioNode[]
}

export interface ScenarioNode {
  id: number
  createdAt: number
  updatedAt: number
  isDeleted: boolean
  deletedAt: number
  deletedBy: string
  label: string
  key: string
  type: ScenarioNodeType
  content: string
  variableKey: string
  prevNodeKey: string
  nextNodeKey: string
  position: number
  options: ScenarioNodeOption[]
  scenario: Scenario
}

export interface ScenarioNodeOption {
  label: string;
  nextNodeKey: string;
  position: number;
}

export enum ScenarioNodeType {
  Message = 'MESSAGE',
  Choice = 'CHOICE',
  Input = 'INPUT',
  End = 'END',
}

export enum ScenarioStatus {
  Draft = 'DRAFT',
  On = 'ON',
  Off = 'OFF',
}

